export enum AggregateBy {
  SearchProfile,
  Documents
}
